import getFieldValue from '../form_wizard/elements/getFieldValue';
import getForm from '../form_wizard/elements/getForm';
import getPanelCount from '../storage/getPanelCount';
import getStepId from '../form_wizard/elements/getStepId';
import getClientId from '../storage/getClientId';
import getVisitorId from '../storage/getVisitorId';

// PII feilds to avoid including in data layer
const PII_FIELDS = ['full_name', 'email', 'phone_number'];

export default function(element) {
  const TRACKING_EVENT = 'lead_form_selection';
  const form = getForm(element);
  const formVersion = getFieldValue(form, 'leadform');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'lead_form_selection',
    contents: getContents(form, element) || '',
    panel_name: getStepId(element),
    panel_count: getPanelCount(TRACKING_EVENT),
    panel_type: element.dataset.component,
    leadform_id: formVersion,
    visitor_id: getVisitorId(),
    client_id: getClientId(),
  });
}

// Safty checks to ensure no PII is included in data layer
const getContents = (form, element) => {
  const is_pii =  PII_FIELDS.includes(getStepId(element));
  return is_pii ? '' : getFieldValue(form, element);
};
